import { ISession } from 'utils/types';

export const SESSION_DEFAULT_REQUEST_BODY: Pick<ISession, 'returnSession'> = {
	returnSession: 'YES',
};
